// Returns the dollar shortfall if `cap` is not an exact multiple of `cpa` (compared in
// cents to avoid float rounding errors), or null when it divides evenly / inputs are
// invalid. Spend accumulates in increments of `cpa`, so a non-multiple cap can never be
// spent exactly — it always stops short by the remainder.
export function capShortfall(cap, cpa) {
  const capNum = parseFloat(cap);
  const cpaNum = parseFloat(cpa);
  if (!Number.isFinite(capNum) || !Number.isFinite(cpaNum) || capNum <= 0 || cpaNum <= 0) return null;
  const capCents = Math.round(capNum * 100);
  const cpaCents = Math.round(cpaNum * 100);
  if (cpaCents === 0) return null;
  const remainderCents = capCents % cpaCents;
  return remainderCents === 0 ? null : remainderCents / 100;
}

// Sanitizes a raw CPA input string down to digits with at most 2 decimal places.
export function sanitizeCpaInput(raw) {
  const digitsOnly = raw.replace(/[^0-9.]/g, "");
  const parts = digitsOnly.split(".");
  if (parts.length > 2) return parts[0] + "." + parts.slice(1).join("").slice(0, 2);
  if (parts[1]?.length > 2) return parts[0] + "." + parts[1].slice(0, 2);
  return digitsOnly;
}
